import { SVGProps, Ref, forwardRef } from 'react';

export const DrawerFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.323 12.127C2.319 4.722 4.03 2 8.7 2h6.6c4.669 0 6.381 2.722 7.377 10.127q.068.502.122.973h-6.673l-.75 2H8.624l-.75-2H1.2q.054-.472.122-.973M1.04 14.9C.727 20.162 2.191 22 6.22 22H17.78c4.03 0 5.493-1.838 5.179-7.1h-5.585l-.75 2H7.376l-.75-2z"
                fill="currentColor"
            />
        </g>
    </svg>
));
DrawerFilledSize24Glyph.displayName = 'DrawerFilledSize24Glyph';
